import { SET_SLIDER_INDEX } from '../actions/sliderActions'
export default (state = {index: 0}, { type, data = 0 }) => {
  switch (type) {
    case SET_SLIDER_INDEX:
      return {index : data}
    default:
      return state
  }
}
